<i [class]="_iconClass" aria-hidden="true"></i>
{{ (value || 0) * 100 | number: "1.2-2" }} %
